import React from 'react';
import { withTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { ButtonToolbar, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import validate from './Validate';
import Select from '../../../shared/components/form/Select';
import DateField from '../../../shared/components/form/DateField';
import HourField from '../../../shared/components/form/HourField';
import renderField from '../../../shared/components/form/RenderField';
import TextAreaField from '../../../shared/components/form/TextAreaField';
import DropZoneDragAndDrop from '../../../shared/components/form/DropZoneDragAndDrop';
import {
  APPLICATION_PDF,
  TEXT_PLAIN,
  FILE_EXTENSION,
  TEXT_RTF,
} from '../../../shared/utils/constants';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';

const RecordOccurrencesForm = (props) => {
  const { t, backHandler, saveForm, dto, classes, students } = props;

  return (
    <Form
      initialValues={{ ...dto }}
      onSubmit={saveForm}
      validate={validate}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="form">
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.type')}</span>
            <div className="form_form-group-field">
              <Field
                name="type"
                component={Select}
                options={[]}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group--2_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.date')}
              </span>
              <div className="form__form-group-field">
                <Field name="date" component={DateField} />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.hour')}
              </span>
              <div className="form__form-group-field">
                <Field name="hour" component={HourField} />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.class')}</span>
            <div className="form_form-group-field">
              <Field
                name="class"
                component={Select}
                options={classes}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.involved')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="involved"
                isMulti
                closeMenuOnSelect={false}
                component={SelectVirtualized}
                options={students}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.title')}</span>
            <div className="form_form-group-field">
              <Field
                name="title"
                component={renderField}
                placeholder={t('general.placeholders.type-here')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.description')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="description"
                component={TextAreaField}
                placeholder={t('general.placeholders.type-here')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.files')}</span>
            <div className="form__form-group-field">
              <Field
                name="files"
                component={DropZoneDragAndDrop}
                accept={[TEXT_RTF, APPLICATION_PDF, TEXT_PLAIN]}
                fileExtensions={[FILE_EXTENSION]}
              />
            </div>
          </div>
          <ButtonToolbar className="form__button-toolbar">
            <Button color="primary" onClick={backHandler}>
              {t('general.back')}
            </Button>
            <Button color="success" type="submit">
              {t('general.save')}
            </Button>
          </ButtonToolbar>
        </form>
      )}
    />
  );
};

RecordOccurrencesForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  saveForm: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  classes: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  students: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
};

export default withTranslation('common')(RecordOccurrencesForm);
